/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ComponentAxle } from './ComponentAxle';
import type { ComponentSide } from './ComponentSide';
/**
 * Solved transmission node.
 */
export type SolvedTransmission = {
    name: string;
    axle?: ComponentAxle;
    side?: ComponentSide;
    mass?: number;
    cost?: number;
    in_powers: Array<number>;
    out_powers: Array<number>;
    losses: Array<number>;
    losses_ratio: Array<number>;
    solved_component_type?: SolvedTransmission.solved_component_type;
    gear_ratios: Array<number>;
    gear_ratios_optimal?: Array<number>;
    in_speeds: Array<number>;
    out_speeds: Array<number>;
    in_torques: Array<number>;
    out_torques: Array<number>;
    losses_torque?: Array<number>;
};
export namespace SolvedTransmission {
    export enum solved_component_type {
        TRANSMISSION = 'transmission',
    }
}

